module.exports = __webpack_public_path__ + "img/ILEK_80X30.1e1d665c.png";